import React, { Component, useState, useEffect  } from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import queryString from 'query-string';
/*
import useWebInstallPrompt from '../hooks/useWebInstallPrompt';
*/







function Msme (props) {
	//&id=14&tv=123916995
let customspremurl='https://customsprem.gov.tc/';
let resturl='https://customsprem.gov.tc/';

const [dowait, setDowait] = useState({on:false});
	
const queryStringParams = queryString.parse(window.location.search);
if (queryStringParams.drv!=undefined){
	resturl='http://127.0.0.1:3001/';
	customspremurl='http://127.0.0.1:3001/';
	console.log('resturl: '+resturl);
	//console.log('queryStringParams: '+resturlJSON.stringify(queryStringParams));
	}//end if
	


const [cred, setCred] = useState({
email: ""
, pwd: ""
, otp: ""
, EMAIL: ""
, IP: ""
, otpsent: false
, cbtrust: ""
, authpassed: false
, devicetrusted: null
, devicename:""
});	
//, needpwd: false
useEffect(() => {
	document.title =   "TCI Customs Msme";	
	getipaddress();
	document.getElementsByTagName('body')[0].classList.add("loginbody");

/*
	setCred((prev)=>{
		return {...prev, email:"adj", pwd:"adj123"}
	});
*/

	if (document.getElementsByName('email')[0])
		document.getElementsByName('email')[0].focus();
	
	
	//const event = new Event('beforeinstallprompt')
//window.dispatchEvent(event)
},[]);



useEffect(() => {
	
	//if the device is not trusted, verify otp via email inbox
	sessionStorage.setItem("EMAIL", "");
	
	console.log("will check cred.authpassed: "+cred.authpassed);
	
	if (cred.authpassed==true){
		//		getotp();		
		if (cred.devicetrusted==null)
			checkdevicetrust();
		else if (cred.devicetrusted==1){
			exitlogin(cred.email);
			}//end else
		else{
			disableusername();
			getotp();
			}//end 
			
		}
		

},[cred.authpassed, cred.devicetrusted]);




useEffect(() => {
			
	if (cred.otpsent==true){
		if (document.getElementsByName('email')[0]){
			document.getElementsByName('email')[0].readOnly=true;
			if (!document.getElementsByName('email')[0].classList.contains("gnsbro"))
				document.getElementsByName('email')[0].classList.add("gnsbro");
			}//end if
			
		if (document.getElementsByName('pwd')[0]){
			document.getElementsByName('pwd')[0].readOnly=true;
			if (!document.getElementsByName('pwd')[0].classList.contains("gnsbro"))
				document.getElementsByName('pwd')[0].classList.add("gnsbro");
			
			}//end if

		if (document.getElementsByName("otp")[0])
			document.getElementsByName("otp")[0].focus();	
		}//end if
	else{
		if (document.getElementsByName('email')[0]){
			document.getElementsByName('email')[0].readOnly=false;
			if (document.getElementsByName('email')[0].classList.contains("gnsbro"))
				document.getElementsByName('email')[0].classList.remove("gnsbro");
			}//end if

		if (document.getElementsByName('pwd')[0]){
			document.getElementsByName('pwd')[0].readOnly=false;
			if (document.getElementsByName('pwd')[0].classList.contains("gnsbro"))
				document.getElementsByName('pwd')[0].classList.remove("gnsbro");
			}//end if


		}//end else
	
},[cred.otpsent]);



const navigate = useNavigate();	

const setLoginCred = () =>{
//const email=document.getElementsByName('email')[0].value;

};

function disableusername(){
			document.getElementsByName("email")[0].readOnly=true;
			document.getElementsByName("email")[0].classList.add("gnsbro");
			document.getElementsByName("pwd")[0].readOnly=true;
			document.getElementsByName("pwd")[0].classList.add("gnsbro");

}//end func



function clickLogin(e){
	
	/*
	if user already authenticated then check if the otp matches
	*/
	
	if (cred.authpassed==false)
		loginad();
	else
		getotp();
	
}//end func

async function loginad(){
var md5 = require('md5');

const email=(""+cred.email).trim();
const pwd=(""+cred.pwd).trim();

if (email=="" || pwd==""){
	showsnackbar("please enter username and password");
	return;
	}//end if

const params={
	username:email
	,password:md5(pwd)
	};

console.log("params: "+JSON.stringify(params));

		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };
setDowait({on:true});

	  await fetch(customspremurl+'rarauthadng/auth',requestOptions)
		  .then(res => res.json())
		  .then(res => afterloginad(res))
		  .catch(err => console.log(err));
		  
}//end func

function afterloginad(res){
	/*
	changes 9th Nov 2024
	(i)  logging in with AD_USERNAME .insertloginlog changed to accept AD_USERNAME only not EMAIL
	(ii)  when user click login we can request OTP match before call authad, unless the device is trusted by user
	*/
	console.log("afterloginad res: "+JSON.stringify(res));
	setDowait({on:false});
	let authOk=false;
	if (res.auth){
		authOk=(res.auth=="true" || res.auth==true)?true:false;
		}//end if
	
	if (authOk==true){
		//checklocalstorage();
		}
	else
		showsnackbar("login failed!");
	
	setCred((prev)=>{
		return {...prev, authpassed:authOk}
	});		
	
	
	//console.log("afterloginad: "+JSON.stringify(res));
}//end func



async function checkdevicetrust(){

let trust=localStorage.getItem(cred.email+"@customsapps.gov.tc");
console.log("checkdevicetrust trust: "+trust);
if (!trust)
	trust="";
else if (trust==null)
	trust="";

if (trust==""){
	setCred((prev)=>{
		return {...prev, devicetrusted:0}
	})	;
	return;
	}//end if

/*
this check to verify if the trust data on the device
matches the database
*/
const params={
	cred:cred
	, trust:trust
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };	
  
  setDowait({show:true});
	
  await fetch(resturl+'rarlogin/trustdevice',requestOptions)
      .then(res => res.json())
      .then(res => 	{aftercheckdevicetrust(res);  } )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftercheckdevicetrust(res){
let MATCH_COUNT=0;
if (res.length)
	if (res.length==1){
		MATCH_COUNT=res[0].MATCH_COUNT;
		sessionStorage.setItem("TRUSTED_DEVICE", res[0].DEVICE_NAME);
		}//end if
		

setCred((prev)=>{
	return {...prev, devicetrusted:MATCH_COUNT}
})	;
	
}//end func



function getipaddress(){
		
fetch('https://api.ipify.org?format=json',{ method: 'GET' })
  .then(res => res.json())
  .then(res => aftergetipaddress(res) )
  .catch(err => getipaddresserr(err) );	
  
}//end func

function getipaddresserr(err){
setCred((prev)=>{
	return {...prev, IP:"0.0.0.0" }
	});
console.log(err);
}//end func

function aftergetipaddress(res){
	
setCred((prev)=>{	
return {...prev, IP:res.ip} 
	});
	
}//end func



function getotp(){
//document.getElementsByName('pwd')[0].value
//document.getElementsByName('email')[0].value
// we will have to find and send the email matching email
//email:cred.email+"@gov.tc"
//must modify SP_ONETIMEPASSWORD to check email for @.  If absent assume its AD_USERNAME
const email=(""+cred.email).trim();
if (email==""){
	console.log("abort getotp() for email==''");
	return;
	}
	
const params={
	email:cred.email
	,ip:''
	,otp: cred.otp
	};

//console.log('getotp params'+JSON.stringify(params));

		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };

	setDowait({on:true});
	  fetch(resturl+'rarlogin/getotp',requestOptions)
		  .then(res => res.json())
		  .then(res => aftergetotp(res))
		  .catch(err => console.log(err));

}//end func


function exitlogin(email){
sessionStorage.setItem("EMAIL", email);
if (cred.cbtrust==1)
	promptdevicename();
else
	navigate('/msme');
}//end func

function aftergetotp(res){
setDowait({on:false});
console.log('res: '+JSON.stringify(res));
if (cred.otpsent==true){
	if (res[0].MATCH_OTP==1){
		exitlogin(res[0].GOV_EMAIL);//
/*
setCred((prev)=>{
			return {...prev, authpassed:true}
		});
*/		
		}//end if
	else
		showsnackbar('login failed');
	}//end if
else{
	setCred((prev)=>{ return {...prev,otpsent:true} }) ;
	showsnackbar('please check your email inbox for one-time-password');
	document.getElementsByName("pwd")[0].focus();
	}//end if

	
}//end func

function handleChange(e){
	
const {name,value}= e.target;
//console.log("handleChange: "+name+", "+value);
setCred((prev)=>{
	return {...prev, [name]:value}
});
	
}//end func








function afteraduserdevice(res){
	console.log("afteraduserdevice: "+JSON.stringify(res));
	let trustdevice=false;
	if (res.length)
		if (res.length>0)
			if (res[0].MATCH_COUNT>0)
				trustdevice=true;
			
	if (trustdevice==true)
		exitlogin(cred.email);
	else
		getotp();
}//end func


function devicenameChangeOld(e){
	setCred((prev)=>{
		return {...prev, [e.target.name]:e.target.value}
	});
}//end func

async function trustthisdevice(e){
	const devicename=(""+cred.devicename).trim();
	if (devicename.length<5){
		showsnackbar("the device name must me 5 characters or more");
		return;
		}//end if
	

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {cred:cred, trust:"", USERNAME:sessionStorage.getItem("EMAIL")} )
  };	
  
  setDowait({show:true});
	
  await fetch(resturl+'rarlogin/trustdevice',requestOptions)
      .then(res => res.json())
      .then(res => 	{aftertrustthisdevice(res);  } )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftertrustthisdevice(res){
	
console.log('aftertrustthisdevice: '+JSON.stringify(res));	
	
let TRUST="";
if (res.length)
	if (res.length==1)
		TRUST=res[0].TRUST;

if (TRUST=="")	
	showsnackbar("that failed!  please try again or contact admin")
else{
	localStorage.setItem(cred.email+"@customsapps.gov.tc",TRUST);
	showsnackbar("the device is now trusted");
	toggleModalsm();
	navigate("/msme");
	}//end else
		
		
}//end func

function promptdevicename(){
	
document.getElementsByName("cbtrust")[0].checked=false; 
toggleModalsm();
document.getElementsByName("devicename")[0].value='';
document.getElementsByName("devicename")[0].focus();
	
}//end func


function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");

	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func





const handleFocus = (e) => {
	e.target.select();
}


const location = useLocation();
console.log('location.pathname: '+location.pathname);
console.log('window.location: '+window.location);



      window.addEventListener("keypress", function (event) {
         // detect event key
         if (event.keyCode == 13) {
			 /*document.getElementById("btnlogin").click();*/
			 
         }
      });

/*
const deviceName = navigator?.userAgentData?.platform || navigator?.platform;
ReactGA.initialize(`${process.env.REACT_APP_GA_ID}`, {
	
	//getDeviceName()
  gaOptions: {
    device_name: deviceName,
    page_location: window.location.href,
  },
});

*/

     return (
		<>

	<table border="0" align='center' id="tbllogin" >
	<tbody>
	<tr>
	<td align='center'  >
		<img src='img/logo.jpg' height='90' border='0' />
	</td>
	</tr>
	<tr>
	<td align='center'>
		<span className='logintextlarge'>Customs Apps</span>
		<div className='logintextsmall'>Ministry of Immigration<br/>and Border Services<br/>Turks and Caicos Islands {cred.authpassed?"aa":"bb"} ss</div>
		
	</td>
	</tr>
		  <tr>
		  <td align='center' className="inputcellpad" ><input type="text" id="email" name='email' value={cred.email} onChange={(e)=>{handleChange(e)}} placeholder="email" autoComplete='on'  onFocus={handleFocus}  /></td>
		  </tr>
		  <tr>
		  <td align='center' className="inputcellpad" ><input type="password" placeholder="password" id="pwd" name='pwd' onChange={(e)=>{handleChange(e)}} value={cred.pwd}  autoComplete='off'  onFocus={handleFocus}  /></td>
		  </tr>
	{cred.otpsent==true && <>
		  <tr>
		  <td align='center' className="inputcellpad" ><input type="password" placeholder="one-time password" id="otp" name='otp' onChange={(e)=>{handleChange(e)}} value={cred.otp}  autoComplete='off'  onFocus={handleFocus}  /></td>
		  </tr>
		  <tr>
		  <td align='center' className="inputcellpad" >
			<input type="checkbox"  name="cbtrust" id="cbtrust" value="1" onClick={(e)=>{handleChange(e)}} /><label htmlFor="cbtrust" className="hand" >I trust this device</label>
		  </td>
		  </tr>
		  </>
	}
	
		  <tr>
		  <td align='center' className="inputcellpad" >
		  
			{dowait.on && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			
		  {!dowait.on && <button className="button" id="btnlogin" onClick={ (e) => { clickLogin(e); } } >login</button> }
						
	
		  </td>
		  </tr>
		  <tr>
		  <td align='center' className="inputcellpad" >&nbsp;</td>
		  </tr>
	</tbody>
	</table>


<div align='center' id="snackbar" ></div>

<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button">&times;</span>
        <div  id='modalsmtext' >
		<div align='left' >
		A trusted device is one that you control access to such as your mobile phone.
		<br/>You will not be required to complete 2-step verification on this device if you choose to trust it.

		<br/>Do not proceed to trust this device if you are using a public or shared device like a computer at a library or internet cafe.
		<p>
			Please give this device a name if you will trust it:
			<br/><input name="devicename" value={cred.devicename} onChange={(e)=>{handleChange(e);}} style={{textAlign:"center"}} autoComplete="off"  placeholder="device name " />
			&nbsp;&nbsp;(length of name must be 5 or more)
		</p>
		</div>
		
<br/>
		<button className="button" onClick={(e)=>{trustthisdevice(e);}} >trust this device</button>
		</div>
    </div>
</div>
	
	</>
);

}//end class

{
/*
onClick="document.getElementById('id01').style.display='none'"
onClick="document.getElementById('id01').style.display='none'"
*/
}

export default Msme; 

